import { useState } from "react";
import { FullPageContainer } from "../../components/layout/container/FullPageContainer";
import { ContentContainer } from "../../components/container/ContentContainer";
import { Title, Flex, em } from "@mantine/core";
import { Chip } from "@mantine/core";
import { HistoryList } from "../../components/list/HistoryList";
import { companyHistory, getFlatHistory, getGroupStartIndices } from "../../data/companyHistory";
import styled from "styled-components";
import { useViewportSize } from "@mantine/hooks";
import { FadeIn } from "../../components/triggerWrapper/FadeIn";
import { useMediaQuery } from "@mantine/hooks";

const Wrapper = styled(Flex)`
	margin: 24px 0px;
	position: relative;
	-webkit-mask-image: linear-gradient(
		to top,
		rgba(0, 0, 0, 0) 0%,
		rgba(0, 0, 0, 1) 10%
	);
	mask-image: linear-gradient(
		to top,
		rgba(0, 0, 0, 0) 0%,
		rgba(0, 0, 0, 1) 10%
	);
`;

const HistoryContainer = styled(Flex)`
	position: relative;
	overflow: hidden;
`;

const TimeSlotWrapper = styled(Flex)`
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: ${(props) => `${props.$top}px`};
	transition: top 0.4s ease-in-out;
`;

const TimeSlot = styled(Flex)`
	position: absolute;
	top: ${(props) => props.$top};
	left: 0;
	opacity: ${(props) => (props.$isTrigger ? 1 : 0)};
	transition: top 0.3s ease-in ${(props) => props.$delay}, opacity 0.3s ease-in ${(props) => props.$delay};
`;

const Timeline = styled(Flex)`
	position: absolute;
	left: calc(50% - 0.5px);
	bottom: 0;
	width: 1px;
	height: 100%;
	z-index: -1;
`;

export const CompanyHistorySection = () => {
	const isTrigger = true;

	const flatHistory = getFlatHistory(companyHistory);
	const groupIndices = getGroupStartIndices(companyHistory);
	const yearSelect = [...groupIndices].reverse();

	const { height } = useViewportSize();
	const amount = "120px";

	const isMobile = useMediaQuery(`(max-width: ${em(750)})`);
	const itemGap = 72;
	const itemGapMobile = 52;

	const gap = isMobile ? itemGapMobile : itemGap;
	const [selectedStartIndex, setSelectedStartIndex] = useState(0);
	const position = selectedStartIndex * -gap;

	const onChangeTimeSlot = (value) => {
		setSelectedStartIndex(Number(value));
	};

	return (
		<FullPageContainer>
			<ContentContainer h={"100%"}>
				<Flex
					direction={"column"}
					align={"center"}
					w={"100%"}
					gap={isMobile ? 16 : 48}
				>
					<FadeIn isTrigger={isTrigger} amount={amount} delay={"0.2s"}>
						<Title
							style={{ whiteSpace: "break-spaces" }}
							c={"white"}
							ta={"center"}
							order={isMobile ? 3 : 1}
						>
							{isMobile
								? `어니스트AI가 걸어온\n혁신의 역사`
								: `어니스트AI가 걸어온 혁신의 역사`}
						</Title>
					</FadeIn>
					<FadeIn
						style={{ width: "100%" }}
						isTrigger={isTrigger}
						amount={amount}
						delay={"0.4s"}
					>
						<Chip.Group
							multiple={false}
							value={String(selectedStartIndex)}
							onChange={onChangeTimeSlot}
							justify="center"
							w={"100%"}
						>
							<Flex
								wrap={"wrap"}
								justify={"center"}
								w={"100%"}
								gap={isMobile ? 4 : 16}
							>
								{yearSelect.map((item, i) => (
									<Chip
										icon={null}
										key={i}
										size={isMobile ? "sm" : "md"}
										color={"white"}
										variant={"outline-white"}
										value={String(item.startIndex)}
										checked={item.startIndex === selectedStartIndex}
									>
										{item.label}
									</Chip>
								))}
							</Flex>
						</Chip.Group>
					</FadeIn>
					<FadeIn
						style={{ width: "100%" }}
						isTrigger={isTrigger}
						amount={amount}
						delay={"0.6s"}
					>
						<Wrapper direction={"column"} align={"center"}>
							<Timeline bg={"gray.7"} />
							<HistoryContainer
								direction={"column"}
								align={"center"}
								w={isMobile ? "100%" : "568px"}
								h={isMobile ? (height || window.innerHeight) - 120 : (height || window.innerHeight) - 360}
							>
								<TimeSlotWrapper $top={position}>
									{flatHistory.map((item, i) => (
										<TimeSlot
											key={`${item.date}-${i}`}
											$isTrigger={isTrigger}
											w={"100%"}
											$top={
												isTrigger
													? `${i * gap}px`
													: `${Math.max(0, i - 1) * gap}px`
											}
											$delay={`${i * 0.03}s`}
											justify={i % 2 === 0 ? "start" : "end"}
										>
											<HistoryList
												title={item.title}
												date={item.date}
												position={i % 2 === 0 ? "left" : "right"}
												isMobile={isMobile}
											/>
										</TimeSlot>
									))}
								</TimeSlotWrapper>
							</HistoryContainer>
						</Wrapper>
					</FadeIn>
				</Flex>
			</ContentContainer>
		</FullPageContainer>
	);
};
